import { authenticatedApiFetch } from "../../common/helpers";
import { isLenderPortfolioApiEnabled } from "../../common/config";

import { mapSummaryFromJson } from "./approvalMappers";

export function resetToInitialState() {
  return;
}

export async function fetchLenderPortfolio() {
  if (!isLenderPortfolioApiEnabled()) return {};
  const result = await authenticatedApiFetch(
    `lender/portfolio`
  );
  return mapSummaryFromJson(result);
}

export async function fetchLenderPortfolioV2(params) {
  if (!isLenderPortfolioApiEnabled()) return {};
  const result = await authenticatedApiFetch(
    `lender/portfolio`,
    "GET",
    params,
    {},
    "v2"
  );
  return result && result.data;
}
